module.exports = __webpack_public_path__ + "9d7ed741dd469d05d7a31f1b3a91b78d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/RRR.jpg
// module id = 480
// module chunks = 0